import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from './components/Navbar';
import AppRoutes from './routes/AppRoutes';
import { AuthProvider } from './context/AuthContext';
import Footer from './components/Footer';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import './index.css';


const initialOptions = {
  "client-id": "AcEIxQKc2_ZM9wKw-Y_BQVuCkJ89keiFBPgvoXCEPITsuNmHjDz-53s_g0pUPOwZrldJo7RoXKiusmco",
  currency: "MXN",
  intent: "capture",
};

function App() {
  return (
    <GoogleOAuthProvider clientId="36976509453-ivqbvcsbql9630n9omqafkn7ooqapote.apps.googleusercontent.com">
      <PayPalScriptProvider options={initialOptions}>
        <AuthProvider>
          <Router basename="/fancyplus">
            <div className="flex flex-col min-h-screen">
              <Navbar />
              
              <main className="flex-grow pt-20 pb-10 bg-gradient-to-tr from-purple-600 via-indigo-500 to-blue-400 animate-gradient">
                <AppRoutes />
              </main>
              
              <Footer />
            </div>
          </Router>
        </AuthProvider>
      </PayPalScriptProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
